
/* ===== VELANTIS_RELAUNCH — promo de relanzamiento (tira + toast + carrito) ===== */
(function(){
  var DEST='#/best-sellers';
  function go(){ location.hash=DEST; if(window.VelantisCart&&window.VelantisCart.close) window.VelantisCart.close(); }
  // (1) tira clicable
  var strip=document.getElementById('promoStrip');
  if(strip){ strip.addEventListener('click',go);
    strip.addEventListener('keydown',function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); go(); } }); }
  // (3) recordatorio del carrito: al tocar, cierra carrito y va a elegir
  var cr=document.getElementById('cartRelanz'); if(cr) cr.addEventListener('click',function(){ if(window.VelantisCart&&window.VelantisCart.close) window.VelantisCart.close(); });
  // (2) toast en producto
  var toast=document.getElementById('promoToast'), tX=document.getElementById('promoToastX');
  var tTimer=null, closedFor='';
  function showToast(){ if(!toast)return; clearTimeout(tTimer); toast.classList.add('show'); tTimer=setTimeout(hideToast,10000); }
  function hideToast(){ if(!toast)return; clearTimeout(tTimer); toast.classList.remove('show'); }
  if(tX) tX.addEventListener('click',function(){ closedFor=location.hash; hideToast(); });
  function onRoute(){
    var isProd=/^#\/p\//.test(location.hash||'');
    if(isProd){ if(closedFor!==location.hash){ setTimeout(showToast,650); } }
    else hideToast();
  }
  window.addEventListener('hashchange',onRoute);
  if(document.readyState!=='loading') onRoute(); else document.addEventListener('DOMContentLoaded',onRoute);
})();
